import { render, staticRenderFns } from "./BuildingSocietyDocuments.vue?vue&type=template&id=c57d25e0&scoped=true&"
import script from "./BuildingSocietyDocuments.vue?vue&type=script&lang=js&"
export * from "./BuildingSocietyDocuments.vue?vue&type=script&lang=js&"
import style0 from "./BuildingSocietyDocuments.vue?vue&type=style&index=0&id=c57d25e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57d25e0",
  null
  
)

export default component.exports